// export { default as axis } from './axis';
// export { default as box } from './box';
// export { default as grid } from './grid';
// export { default as labels } from './labels';
// export { default as range } from './range';
// export { default as tooltip } from './tooltip';

// export { default as domPointLabel } from './domPointLabel';
// export { default as legend } from './legend';
// // export { default as line } from './line';
// export { default as pie } from './pie';
// export { default as point } from './point';

import axis from './axis';
import box from './box';
import point from './point';
import lineArea from './lineArea';
import grid from './grid';
import labels from './labels';
import range from './range';
import tooltip from './tooltip';
import legend from './legend';

export default {
  axis, box, point, lineArea, grid, labels, range, tooltip, legend,
};
